<template>
    <div class="modal-status-form-auth">
        <div class="modal-status-form-auth__title"
            v-text="'Авторизация'"
        />
        <div class="modal-status-form-auth__description">
            Для продолжения необходимо ознакомиться и&nbsp;согласиться с&nbsp;условиями&nbsp;ниже.
            <br>
            После этого вы будете перенаправлены в сервис авторизации для входа через Госуслуги и&nbsp;затем сможете вернуться к&nbsp;заполнению&nbsp;формы.
        </div>
        <div class="modal-status-form-auth__list">
            <div class="modal-status-form-auth__list-item">
                <ui-checkbox-with-text
                    v-model="reglamentDostupa"
                >
                    Я ознакомлен и согласен с условиями <a v-bind:href="urls.reglamentDostupa" target="_blank">Регламента доступа и использования сервиса Статус.Онлайн - Личный кабинет акционера.</a>
                </ui-checkbox-with-text>
            </div>
            <div class="modal-status-form-auth__list-item">
                <ui-checkbox-with-text
                    v-model="privacyPolicy"
                >
                    Я ознакомлен и согласен с условиями <a v-bind:href="urls.privacyPolicy" target="_blank">Политики конфиденциальности.</a>
                </ui-checkbox-with-text>
            </div>
            <div class="modal-status-form-auth__list-item">
                <ui-checkbox-with-text
                    v-model="personalData"
                >
                    Я ознакомлен и согласен с условиями <a v-bind:href="urls.personalData" target="_blank">Политики в отношении обработки персональных данных в АО "Статус".</a>
                </ui-checkbox-with-text>
            </div>
            <div class="modal-status-form-auth__list-item">
                <ui-checkbox-with-text
                    v-model="userAgreement"
                >
                    Я ознакомлен и согласен с условиями <a v-bind:href="urls.userAgreement" target="_blank">Пользовательского соглашения.</a>
                </ui-checkbox-with-text>
            </div>
            <div class="modal-status-form-auth__list-item">
                <ui-checkbox-with-text
                    v-model="reglamentIt"
                >
                    Я ознакомлен и согласен с условиями <a v-bind:href="urls.reglamentIt" target="_blank">Регламента информационно-технологического взаимодействия</a> между АО "Статус" и ООО "Симпл Эстэйт".
                </ui-checkbox-with-text>
            </div>
            <div class="modal-status-form-auth__list-item">
                <ui-checkbox-with-text
                    v-model="consent"
                >
                    Я даю свое <a v-bind:href="urls.consent" target="_blank">согласие</a> на обработку персональный данных АО "Статус".
                </ui-checkbox-with-text>
            </div>
        </div>
        <div class="modal-status-form-auth__description _error"
             v-text="'Чтобы продолжить, необходимо ваше согласие'"
             v-show="!isValid"
        />
        <div class="modal-status-form-auth__button"
            v-if="getAuthUrlResult"
            >
            <ui-button
                v-bind:href="getAuthUrlResult.url"
                target="_self"
                v-bind:disabled="!isValid"
                >
                Пройти авторизацию
            </ui-button>
        </div>
        <template v-if="getAuthUrlError">
            <div class="modal-status-form-auth__description _error"
                v-text="'Ошибка запроса ссылки авторизации кабинета акционера'"
            />
            <div class="modal-status-form-auth__button">
                <ui-button
                    v-on:click="getLink"
                    >
                    Повторить попытку
                </ui-button>
            </div>
        </template>
    </div>
</template>

<script>
import config from '~/config';
import { mapState } from 'vuex';

export default {
    name: 'modal-status-form-auth',
    data: () => ({
        urls: { ...config.urls.policies.status },
        reglamentDostupa: false,
        privacyPolicy: false,
        personalData: false,
        userAgreement: false,
        reglamentIt: false,
        consent: false,
    }),
    computed: {
        ...mapState('status', [
            'getAuthUrlError',
            'getAuthUrlResult',
        ]),
        isValid() {
            return this.reglamentDostupa &&
                this.privacyPolicy &&
                this.personalData &&
                this.userAgreement &&
                this.reglamentIt &&
                this.consent;
        },
    },
    methods: {
        getLink() {
            this.$store.dispatch('status/getAuthUrl');
        },
    },
    beforeMount() {
        this.$store.state.status.getAuthUrlResult = null;
        this.getLink();
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.modal-status-form-auth {
    &__title {
        .typography-heading();

        margin-bottom: 24px;

        text-align: center;
    }
    &__description {
        .typography-heading();

        margin-bottom: 24px;

        font-weight: normal;
        text-align: center;
        &._error {
            color: @color-accent-negative;
        }
    }
    &__list {
        margin-bottom: 24px;
    }
    &__button {
        width: fit-content;
        margin: 0 auto;
    }
}
</style>
